module.exports = __webpack_public_path__ + "static/media/maggie.115e8f73.jpeg";